import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';

interface AdminSectionTab {
  route: string;
  labelKey: string;
  icon: string;
  exact?: boolean;
}

interface AdminSectionRouteData {
  titleKey?: string;
  descriptionKey?: string;
  tabs?: AdminSectionTab[];
}

@Component({
  standalone: true,
  selector: 'app-admin-section',
  templateUrl: './admin-section.component.html',
  styleUrls: ['./admin-section.component.scss'],
  imports: [CommonModule, RouterModule, TranslateModule],
})
export class AdminSectionComponent {
  get sectionData(): AdminSectionRouteData {
    const data = this.route.snapshot.data as AdminSectionRouteData;
    return data || {};
  }

  constructor(public route: ActivatedRoute) {}

  resolveTabRoute(tabRoute: string): any[] {
    const customersId = readRouteParam(this.route, 'customers_id');
    const customerRouteParam = readAdminCustomerRouteParam(this.route, customersId);
    const base = [
      '/administration',
      customerRouteParam || `${customersId}`,
      this.route.snapshot.routeConfig?.path || '',
    ];
    const normalizedBase = base.filter((part) => !!part);

    if (!tabRoute) {
      return normalizedBase as any[];
    }

    const chunks = tabRoute.split('/').filter(Boolean);
    return [...normalizedBase, ...chunks];
  }
}
